/* eslint-disable no-console */
import _ from 'lodash';

export default class ResourceTranslation {
  constructor(displayNameResolver) {
    this._resources = {};
    this._displayNameResolver = displayNameResolver;
  }

  get(text, languageCode, options = {}) {
    const {
      diag: { featureId }
    } = _.defaults(options, { diag: {} });

    const [displayName, resolved] = this._displayNameResolver.resolve(text);

    if (resolved) {
      console.warn(
        `[i18n] [${featureId}] resolved technical with resources "${text}": "${displayName}"`
      );
    }

    const targetResource = this._resources[languageCode === 'en' ? 'frEn' : 'enFr'];
    const translated = _.get(targetResource, displayName);

    if (translated) {
      console.warn(
        `[i18n] [${featureId}] JSON resource translation "${displayName}": "${translated}"`
      );
    }

    return translated || displayName;
  }
}
